import script from "./widgetValue.vue?vue&type=script&lang=js"
export * from "./widgetValue.vue?vue&type=script&lang=js"

import "./widgetValue.vue?vue&type=style&index=0&id=56a16dcd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a16dcd"],['__file',"src/components/widgets/widgetValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56a16dcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56a16dcd', __exports__)) {
    api.reload('56a16dcd', __exports__)
  }
  
}


export default __exports__